import i18n from 'i18next';
import i18nBackend from 'i18next-http-backend';
import detector from 'i18next-browser-languagedetector';
import { initReactI18next } from 'react-i18next';

const STORAGE_KEY = 'i18nextLng';
if (!window.localStorage.getItem(STORAGE_KEY)) {
  window.localStorage.setItem(STORAGE_KEY, 'es');
}

const loadPath = '/i18n/{{lng}}.json';

i18n
  .use(detector)
  .use(i18nBackend)
  .use(initReactI18next)
  .init({
    fallbackLng: 'es',
    interpolation: {
      escapeValue: false,
    },
    backend: {
      loadPath,
    },
  });

export default i18n;